import { For } from 'solid-js';
import { contacts } from '~/data/config';
import './Contacts.css';

export function Contacts() {
  const yandex = `https://yandex.ru/maps/?text=${encodeURIComponent(contacts.address.yandexMapsQuery)}`;

  return (
    <section class="section contacts" id="contacts">
      <div class="container">
        <div class="section-head" data-reveal>
          <div class="eyebrow">Контакты</div>
          <h2>Свяжитесь удобным способом</h2>
          <p class="section-head__lead">
            Офис в Екатеринбурге. Работаем с заказами по всей России и грузим транспортными компаниями.
          </p>
        </div>

        <div class="contacts__grid">
          <div class="contacts__info" data-reveal>
            <h3 class="contacts__legal">{contacts.legalName}</h3>

            <div class="contacts__item">
              <span class="contacts__item-label">Адрес</span>
              <span class="contacts__item-value">{contacts.address.full}</span>
            </div>

            <div class="contacts__item">
              <span class="contacts__item-label">Телефоны</span>
              <ul class="contacts__phones">
                <For each={contacts.phones}>
                  {(phone) => (
                    <li>
                      <a href={`tel:${phone.tel}`}>
                        <span class="contacts__phones-label">{phone.label}</span>
                        <span class="contacts__phones-value">{phone.value}</span>
                      </a>
                    </li>
                  )}
                </For>
              </ul>
            </div>

            <div class="contacts__item">
              <span class="contacts__item-label">E-mail</span>
              <a class="contacts__email" href={`mailto:${contacts.email}`}>
                {contacts.email}
              </a>
            </div>

            <div class="contacts__item">
              <span class="contacts__item-label">Режим работы</span>
              <span class="contacts__item-value">{contacts.workingHours}</span>
            </div>
          </div>

          <div class="contacts__map" data-reveal>
            <div class="contacts__map-pin" aria-hidden="true">
              <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                <circle cx="12" cy="10" r="3" />
              </svg>
            </div>
            <div class="contacts__map-body">
              <p class="contacts__map-city">Екатеринбург</p>
              <p class="contacts__map-address">{contacts.address.street}</p>
              <p class="contacts__map-zip">{contacts.address.postalCode}</p>
              <a
                class="btn btn--primary contacts__map-btn"
                href={yandex}
                target="_blank"
                rel="noopener noreferrer"
              >
                Открыть в Яндекс Картах <span class="btn__arrow">↗</span>
              </a>
            </div>
            <div class="contacts__map-grid" aria-hidden="true" />
          </div>
        </div>
      </div>
    </section>
  );
}
